module.exports = __webpack_public_path__ + "static/screen_ar.cdf01957.png";


//////////////////
// WEBPACK FOOTER
// ./src/comp/images/screen_ar.png
// module id = 417
// module chunks = 168707334958949